'use strict';

var Marionette = require('backbone.marionette');
var _ = require('underscore');
var $ = require('jquery');

export default Marionette.View.extend({
  className: 'social-media-sharing',
  template: require('./templates/social-media.hbs'),

  initialize: function () {
    this.shares = [
      {
        label:    'Tweet',
        logo:     'fa fa-twitter',
        type:     'twitter',
        shareUrl: 'https://twitter.com/share',
        options:  {
          url:      {
            param: 'url',
            value: null,
          },
          text:     {
            param: 'text',
            value: null,
          },
          via:      {
            param: 'via',
            value: null,
          },
          hashtags: {
            param: 'hashtags',
            value: null,
          },
        },
      },

      {
        label:    'Like',
        logo:     'fa fa-facebook',
        type:     'facebook',
        shareUrl: 'https://facebook.com/sharer/sharer.php',
        options:  {
          url: {
            param: 'u',
            value: null,
          },
        },
      },

      {
        label:    '+1',
        logo:     'fa fa-google',
        type:     'google',
        shareUrl: 'https://plus.google.com/share',
        options:  {
          url: {
            param: 'url',
            value: null,
          },
        },
      },
    ];
  },

  serializeData: function () {
    return {
      shareables: this.createShareables(),
    };
  },

  createShareables: function () {
    var shareables = [];

    _.each(this.shares, function (share) {
      var query = {};

      share.options.url.value = window.location.origin;
      if (share.options.hasOwnProperty('text')) {
        share.options.text.value = window.SETTINGS.social_media_message;
      }
      share.options = _.filter(share.options, function (option) {
        return option.value !== null;
      });

      _.each(share.options, function (value) {
        query[value.param] = value.value;
      });

      query = $.param(query);
      share.shareUrl += '?' + query;
      shareables.push(share);
    });

    return shareables;
  },
});
